const renderFormats = {
  quantity: 'number',
  amount: 'currency',
  client: 'client',
  filtered_amount: 'currency',
  payment_method: 'paymentMethod',
  payment_method_code: 'paymentMethodCode',
  shipping_method: 'shippingMethod',
  coupon: 'couponCategory',
};

export default renderFormats;
